export default "__VITE_PUBLIC_ASSET__b6fbbc2a__"